const mapStyles = {
  width: '100%',
  height: '100%',
  minWidth: '100%',
  minHeight: '100%'
};

export default mapStyles;
